import { useState, useEffect, useCallback } from "react";

interface UseResendCooldownResult {
  cooldown: number;
  startCooldown: () => void;
  resetCooldown: () => void;
}

export const useResendCooldown = (
  durationSeconds: number
): UseResendCooldownResult => {
  const [cooldown, setCooldown] = useState<number>(0);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const startCooldown = useCallback(() => {
    setCooldown(durationSeconds);
  }, [durationSeconds]);

  const resetCooldown = useCallback(() => {
    setCooldown(0);
  }, []);

  return { cooldown, startCooldown, resetCooldown };
};
